export default {
  product: 'Núcleo P',
  invalidParameters: 'Parâmetros inválidos',
  emailRequired: 'E-mail obrigatório',
  userFallback: 'Usuário',
  unavailable: 'indisponível',
  locationUnavailable: 'Localização indisponível',
  browserUnknown: 'Navegador não identificado',
  securityContext: 'Segurança da conta',
  identityVerificationContext: 'Verificação de identidade',
  greeting: 'Olá, {name}!',
  signoff: 'Equipe {productName}',
  ipAddressLabel: 'Endereço IP',
  locationLabel: 'Local aproximado',
  browserLabel: 'Navegador',
  dateTimeLabel: 'Data e hora',
  verificationCodeLabel: 'Código de verificação',
  verificationCodeHint: 'Este código expira em {minutes} minutos.',
  verificationWarning: 'Se você não iniciou esta solicitação, ignore este e-mail e não compartilhe o código.',
  passwordCreatedTitle: 'Senha criada',
  passwordChangedTitle: 'Senha alterada',
  passwordCreatedLead: 'Sua senha foi criada com sucesso em {dateTime}.',
  passwordChangedLead: 'Sua senha foi alterada em {dateTime}.',
  passwordChangedWarning: 'Se não foi você, altere sua senha imediatamente e revise suas configurações de segurança.',
  passwordChangeAttemptTitle: 'Tentativa de alteração de senha',
  passwordChangeAttemptLead: 'Detectamos uma tentativa de alterar a senha da sua conta em {dateTime}, mas a senha atual informada estava incorreta.',
  passwordChangeAttemptWarning: 'Se não foi você, revise suas sessões e altere sua senha imediatamente.',
  newDeviceSubject: 'Novo dispositivo conectado',
  newDeviceTitle: 'Novo dispositivo conectado',
  newDeviceLead: 'Detectamos um novo dispositivo conectado à sua conta.',
  newDeviceText: 'Detectamos um novo dispositivo conectado à sua conta.\n\nData/hora: {when}\nLocal aproximado: {location}\nIP: {ipAddress}\nNavegador: {browserInfo}\n\nSe não foi você, altere sua senha imediatamente.',
  newDeviceWarning: 'Se não foi você, altere sua senha imediatamente e revise suas sessões ativas.',
  firstAccessText: 'Olá, {name}! Este é o código para criar sua senha: {code}. O código é válido por {minutes} minutos. Atenciosamente, Equipe {productName}.',
  firstAccessTitle: 'Criação de senha',
  firstAccessLead: 'Use o código abaixo para criar sua senha.',
  resetTitle: 'Recuperação de senha',
  resetLead: 'Use o código abaixo para redefinir sua senha.',
  mfa: {
    errors: {
      invalidParameters: 'Parâmetros inválidos',
      userNotFound: 'Usuário não encontrado',
      unsupportedMethod: 'Método não suportado',
    },
    email: {
      subject: 'Código de verificação - {productName}',
      text: 'Seu código de verificação é {code}. Ele expira em {minutes} minutos.',
      context: 'Verificação de identidade',
      title: 'Código de verificação',
      lead: 'Use o código abaixo para concluir seu acesso.',
      codeLabel: 'Código de verificação',
      codeHint: 'Este código expira em {minutes} minutos.',
      warning: 'Não compartilhe este código. Se você não iniciou esta solicitação, ignore este e-mail.',
      signoff: 'Equipe {productName}',
    },
  },
  access: 'Acessar',
  accountInactive: 'Conta inativa.',
  accountLocked: 'Conta bloqueada por {minutes} minuto(s).',
  accountLockedHours: 'Conta bloqueada por {hours} hora(s).',
  accountNotFound: 'Conta não encontrada.',
  authAppManualHint: 'Se preferir, use a chave manual abaixo:',
  authAppPrompt: 'Digite o código do autenticador.',
  authAppQrAlt: 'QR Code de autenticação',
  authAppSetupConfirm: 'Confirme digitando um código gerado pelo app.',
  authAppSetupIntro1: 'Ative a verificação da sua conta',
  authAppSetupIntro2: 'Escaneie o QR Code no seu app autenticador.',
  authAppSetupIntro3: 'Esse código protege sua conta e será usado para acessar os produtos, ambientes e serviços vinculados a ela.',
  authentication: 'Autenticação',
  codeExpired: 'Código expirado.',
  confirmNewPassword: 'Confirmar senha',
  changePasswordIntro: 'Confirme sua senha atual e escolha uma nova senha forte.',
  changePasswordSuccess: 'Senha alterada com sucesso.',
  changePasswordTitle: 'Alterar senha',
  createPasswordSuccess: 'Senha criada com sucesso.',
  createSessionExpired: 'Sessão de criação de senha expirada.',
  createPasswordIntro: 'Defina sua nova senha.',
  createPasswordTitle: 'Criar senha',
  enterCredentials: 'Informe seu e-mail e senha para continuar sua operação ',
  email: 'E-mail',
  emailCodeSent: 'Enviamos um código para {email}.',
  errors: {
    PRODUCT_ACCESS_DENIED: 'Seu usuário não tem acesso a este produto.',
    TARGET_PRODUCT_ACCESS_DENIED: 'Seu usuário não tem acesso ao produto solicitado.',
    BACKSITE_ACCESS_DENIED: 'Seu usuário não tem permissão para este ambiente.',
    EMAIL_DELIVERY_FAILED: 'Não foi possível enviar o código por e-mail. Tente novamente em instantes ou fale com o suporte.'
  },
  firstAccess: 'Primeiro acesso',
  firstAccessAlreadyDefined: 'Primeiro acesso já concluído para esta conta.',
  firstAccessCodeSent: 'Enviamos o código para cadastrar sua senha para {email}.<br/>Acesse seu e-mail e digite o código no campo abaixo:',
  firstAccessSubject: 'Criação de senha',

  firstAccessIntro: 'Informe seu e-mail para continuar.',
  footer2: 'Ambiente seguro para acesso aos produtos ',
  forgotPassword: 'Esqueci a senha',
  forgotPasswordIntro: 'Informe seu e-mail para receber o código de recuperação.',
  getCodeByEmail: 'Receber código por e-mail',
  invalidCode: 'Código inválido.',
  mfaDialogTitle: 'Configurar autenticação em duas etapas',
  mfaMethodSelectError: 'Falha ao selecionar método de autenticação.',
  mfaEmailSubject: 'Código de verificação',
  mfaEmailText: 'Seu código de verificação é {code}. Ele expira em {minutes} minutos.',

  mfaSetup: [
    'Sua conta precisa de autenticação adicional.',
    'Escolha o método de verificação.',
    'Recomendamos usar app autenticador.',
    'Você pode configurar agora ou depois.',
    'Mantenha os dados de recuperação em local seguro.',
    'Após configurar, informe o código para continuar.'
  ],
  currentPassword: 'Senha atual',
  currentPasswordInvalid: 'Senha atual incorreta.',
  newPassword: 'Nova senha',
  orgCentralTitle: 'Organização centralizada',
  orgCentralBody: 'Gerencie todos os seus ambientes e serviços em um só lugar.',
  password: 'Senha',
  passwordMismatch: 'As senhas não conferem.',
  passwordNotSet: 'Sua conta ainda não possui senha. Use o fluxo de recuperação.',
  passwordReused: 'Você não pode reutilizar a senha anterior.',
  passwordStrongPolicy: 'Senha fora da política mínima de segurança.',
  problemLogin: 'Problema ao acessar a conta?',
  problemLink: 'Fale com o suporte.',
  supportSelectTitle: 'Fale com o suporte',
  supportSelectMessage: 'Escolha como prefere falar com o suporte de {product}.',
  supportWhatsapp: 'WhatsApp',
  supportEmail: 'E-mail',
  supportEmailRecipientName: 'Suporte Núcleo P',
  supportUnavailable: 'Nenhum canal de suporte está configurado.',
  supportWhatsappMessage: 'Olá, estou com problema para acessar minha conta no {product}.',
  supportEmailSubject: 'Problema de acesso - {product}',
  supportEmailBody: 'Olá, estou com problema para acessar minha conta no {product}.',
  quickEntryTitle: 'Entrada rápida nos seus ambientes',
  quickEntryBody: 'Acesso ágil e simplificado para você focar no que realmente importa.',
  reliability: 'Plataforma confiável utilizada por empresas que buscam eficiência e resultados.',
  remember: 'Lembrar por 7 dias',
  resetCodeExpired: 'Código expirado.',
  resetCodeInvalid: 'Código inválido.',
  resetCodeSent: 'Código de recuperação enviado.',
  resetCodeTitle: 'Código de verificação',
  resetCodeTooManyAttempts: 'Muitas tentativas. Tente novamente mais tarde.',
  resetSubject: 'Recuperação de senha',
  resetText: 'Seu código para redefinir a senha é {code}. Ele expira em {minutes} minutos.',

  resetPasswordIntro: 'Informe sua nova senha.',
  resetPasswordSuccess: 'Senha redefinida com sucesso.',
  resetPasswordTitle: 'Redefinir senha',
  resetSessionExpired: 'Sessão de recuperação expirada.',
  retryInHours: 'Tente novamente em {hours} hora(s).',
  retryIn: 'Tente novamente em {minutes} minuto(s).',
  send: 'Enviar',
  secureAccessTitle: 'Acesso Seguro',
  secureAccessBody: 'Seus dados protegidos com criptografia e as melhores práticas de segurança.',
  securityFooter: 'Ambiente seguro para acesso aos produtos e serviços digitais',
  showQRCode: 'Mostrar QR Code',
  passwordChangedSubject: 'Senha alterada',
  passwordChangedText: 'Olá, {name}! Sua senha foi alterada em {dateTime}. Se não foi você, altere sua senha imediatamente e revise suas configurações. Atenciosamente, Equipe {productName}.',

  passwordChangeAttemptSubject: 'Tentativa de alteração de senha',
  passwordChangeAttemptText: 'Olá, {name}! Detectamos uma tentativa de alterar a senha da sua conta em {dateTime}, mas a senha atual informada estava incorreta. IP: {ipAddress}. Local aproximado: {location}. Navegador: {browserInfo}. Se não foi você, revise suas sessões e altere sua senha imediatamente.',

  passwordCreatedSubject: 'Senha criada',
  passwordCreatedText: 'Olá, {name}! Sua senha foi criada com sucesso em {dateTime}. Atenciosamente, Equipe {productName}.',

  subtitle: 'Soluções digitais para empresas que querem mais controle sobre gestão, dados e operação.',
  title: 'Acesse sua conta',
  exTitle: 'CONEXÃO ESTRATEGICA',
  sessionConflictCancel: 'Cancelar',
  sessionConflictCanceled: 'Login cancelado.',
  sessionConflictContinue: 'Continuar',
  sessionConflictMessage: 'Há outra sessão ativa que será finalizada.<br>Deseja continuar?',
  sessionConflictRevoked: 'Outras sessões foram revogadas.',
  sessionConflictRevokeFailed: 'Não foi possível revogar as outras sessões.',
  sessionConflictTitle: 'Conflito de sessão',
  sessionEndedByNewLoginTitle: 'Sessão encerrada',
  sessionEndedByNewLoginMessage: 'Sua sessão foi encerrada porque esta conta entrou em outro dispositivo.'
};
